import { useQuery } from "@tanstack/react-query";
import { bpas } from "@/api/bpas.service";
import styles from "./CmsBpaSplitDialog.module.css";

type TaxonomyPathProps = {
  taxonomyBpaId: string | null;
};

export function TaxonomyPath({ taxonomyBpaId }: TaxonomyPathProps) {
  const { data } = useQuery({
    queryKey: ["research-split-dialog-taxonomy-ancestors", taxonomyBpaId],
    queryFn: () => bpas.getAncestors(taxonomyBpaId as string),
    enabled: taxonomyBpaId !== null,
    retry: false,
  });

  if (taxonomyBpaId === null || !data || data.length === 0) return null;

  return <p className={styles.taxonomyPath}>{data.map(ancestor => ancestor.name).join(" › ")}</p>;
}
